export default __webpack_public_path__ + "static/media/resumeFinal.e4df6817.png";